export default class GeneralInfo {
    constructor(id, value) {
      this.id = id;
      this.value=value;
    }
  }